import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../PopupCommonStyle.css';
import styles from './Style.module.css';
import { BtnPrimary } from '../../Buttons/BtnPrimary';
import { BtnClose } from '../../Buttons/BtnClose/BtnClose';

export const BlockedCustomerPopup = ({ active, onReturnHome, onClose }) => {
  const titleId = useId();
  const descriptionId = useId();
  const popupRef = useRef(null);

  useEffect(() => {
    if (!active) return undefined;
    const previousFocus = document.activeElement;
    popupRef.current?.querySelector('button')?.focus({ preventScroll: true });
    return () => {
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, [active]);

  if (!active) return null;

  const handleKeyDown = (event) => {
    if (event.key === 'Escape' && onClose) {
      event.preventDefault();
      onClose();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = popupRef.current.querySelectorAll('a[href], button');
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  return createPortal(
    <>
    <div className={styles.backdrop} data-blocked-customer-backdrop aria-hidden="true" />
    <div
      ref={popupRef}
      className="popup show"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      onKeyDown={handleKeyDown}
    >
      <div className="popup-header">
        <h2 id={titleId} className="title">Contact Our Team</h2>
        {onClose ? (
          <BtnClose title="Close" customClass="closeBtn" handleClick={onClose} />
        ) : null}
        <p id={descriptionId} className="titleSub">
          Online booking is currently unavailable for this account. For further assistance,
          please contact our team at{' '}
          <a className="underline" href="mailto:info@natureland.com.sg">info@natureland.com.sg</a>.
        </p>
      </div>
      <div className="popup-footer">
        <BtnPrimary
          label="Return to Homepage"
          handleClick={onReturnHome}
          customClass="w-100 no-icon"
        />
      </div>
    </div>
    </>,
    document.body
  );
};
